import React, { useEffect, useState } from "react";
import { AutocompleteArrayInput, AutocompleteInput, useDataProvider } from "react-admin";
import { fetchAllData } from "../../../dataProvider";

interface IWaveInput {
  source: string;
  label: string;
  schoolId: number;
  isDisabled: boolean;
  multipleSelection?: boolean;

  // Used to check if the dropdown options need to filtered by bus schedule type;
  // null or undefined mean no need to filter
  scheduleTypeFilter?: "to_school" | "from_school" | "cca";
}

const WaveInput = ({ source, label, schoolId, isDisabled, multipleSelection, scheduleTypeFilter }: IWaveInput) => {
  const [busSchedulePlans, setBusSchedulePlans] = useState<IBusSchedulePlans[]>([]);
  const [busScheduleIds, setBusScheduleIds] = useState<number[]>([]);
  const [selectChoices, setSelectChoices] = useState<any>([]);

  const provider = useDataProvider();

  useEffect(() => {
    if (schoolId) {
      fetchAllData("busSchedulePlans", {
        SchoolId: schoolId
      }, {
        field: "Id",
        order: "asc"
      })
        .then((result) => {
          setBusSchedulePlans(result as IBusSchedulePlans[]);
          setBusScheduleIds([]);
          setSelectChoices([]);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  useEffect(() => {
    if (busSchedulePlans.length > 0) {
      const busScheduleIds = busSchedulePlans.map((plan) => plan.busScheduleId);
      setBusScheduleIds([...busScheduleIds]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlans]);

  useEffect(() => {
    if (busScheduleIds.length === 0) {
      setSelectChoices([]);
      return;
    }

    if (busScheduleIds.length === busSchedulePlans.length) {
      provider
        .getMany("busSchedules", { ids: busScheduleIds })
        .then(({ data }) => {
          const busSchedulePlansWithWaveNames = busSchedulePlans
            .map((plan: IBusSchedulePlans) => {
              // Check need to filter data by bus schedule type
              const filteredSchedulesByType = !scheduleTypeFilter
                ? data
                : data.filter((schedule) => schedule.type === scheduleTypeFilter);

              const matchedSchedule = filteredSchedulesByType.find(
                (schedule) => schedule.id === plan.busScheduleId);
              if (matchedSchedule) {
                return {
                  ...plan,
                  waveName: matchedSchedule.name,
                };
              }
              return null;
            })
            .filter((plan) => plan);

          // sort
          busSchedulePlansWithWaveNames.sort((a, b) => {
            // Use localeCompare to compare strings in a case-insensitive manner
            return a.waveName.localeCompare(b.waveName);
          });

          setSelectChoices(busSchedulePlansWithWaveNames);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busScheduleIds]);

  return multipleSelection ? (
    <AutocompleteArrayInput
      choices={selectChoices}
      source={source}
      label={label}
      optionText="waveName"
      disabled={isDisabled}
      fullWidth
    />
  ) : (
    <AutocompleteInput
      choices={selectChoices}
      source={source}
      label={label}
      optionText="waveName"
      disabled={isDisabled}
      fullWidth
    />
  );
}

export default WaveInput;